<template>
  <f7-list-input
    :ref="value"
    class="main-complemetay-data-input padding-top"
    :label="dc.name"
    :placeholder="dc.name"
    validate
    clear-button
    :default-value="dc.defaultValue"
    :required="dc.required"
    :value="localValue"
    :type="inputType"
    @input="emitValueChange($event.target.value)"
  >
    <option
      v-if="dc.values && dc.values.filter((v) => v.value === '').length === 0"
      value=""
    />
    <option
      v-for="optionValue in dc.values"
      :key="optionValue.value"
      :value="optionValue.value"
    >
      {{ optionValue.value }}
    </option>
  </f7-list-input>
</template>

<script>
export default {
  name: 'ComplementaryDataInput',
  props: {
    dc: { type: Object, default: undefined },
    value: { type: [Number, String, Boolean, Array], default: null },
  },

  emits: ['value-change'],

  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    inputType() {
      let dataType = 'text';
      switch (this.dc.dataType) {
        case 0:
        case 3:
          dataType = 'text';
          break;
        case 1:
          dataType = 'date';
          break;
        case 2:
          dataType = 'number';
          break;
        case 4:
          dataType = 'select';
          break;
        default:
          dataType = 'text';
          break;
      }
      return dataType;
    },
  },

  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
  },

  methods: {
    emitValueChange(newValue) {
      this.localValue = newValue;
      this.$emit('value-change', { dcCode: this.dc.code, value: newValue });
    },
  },
};
</script>
